export default "__VITE_ASSET__f0465cd3__"